$(document).ready(function(){
    $(document).on('click touchend', '.accordion .toggler', function(event){
        if (dragging) return;

        event.preventDefault();

        $(this).toggleClass('toggled');
    });

    $(document).on('click touchend', '.expand-all-accordions', function(event) {
        if (dragging) return;

        event.preventDefault();

        $group = $(this).data('group');

        $groupAccordions = '.' + $group + ' .accordion .toggler';

        $(this).hide();
        $($groupAccordions).addClass('toggled');
        $('.collapse-all-accordions[data-group=' + $group + ']').css('display', 'flex');
    });

    $(document).on('click touchend', '.collapse-all-accordions', function(event) {
        if (dragging) return;

        event.preventDefault();

        $group = $(this).data('group');

        $groupAccordions = '.' + $group + ' .accordion .toggler';

        $(this).hide();
        $($groupAccordions).removeClass('toggled');
        $('.expand-all-accordions[data-group=' + $group + ']').css('display', 'flex');
    });
});